import React, { ReactNode, useCallback } from 'react';
import { useSimpleDrag } from '../../../ui/Hooks';
import { Flexer, FlexerProps } from '../../dashboard/elements/LayoutElements';

export type DragOrClick = 'drag' | 'click';
export type DraggableClickableProps = FlexerProps & { children: ReactNode, onAction(type: DragOrClick) };

export const DraggableClickable = React.memo<DraggableClickableProps>(({ children, onAction, ...flexerProps }) => {

    const dragStart = useSimpleDrag(useCallback(dist => {
        if (dist.length() > 10) {
            onAction('drag');
            return false;
        }
        return true;
    }, [onAction]));

    const onClick = useCallback((e: any) => {
        e.preventDefault();
        onAction('click');
    }, [onAction]);

    return <Flexer {...flexerProps} onMouseDown={dragStart} onClick={onClick}>
        {children}
    </Flexer>;
});
